// extracted by mini-css-extract-plugin
export default {"ButtonBacks":"ButtonBack_ButtonBacks__hdejX"};